var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLegend)?_c('metric-chip',{attrs:{"data":_vm.seriesWithMeta}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }